var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUresa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.667 175H158.334M50.0003 150H66.667M58.3337 150V175M87.5003 104.167L75.0003 116.667M141.667 25L166.667 50M100 175C110.392 175.001 120.526 171.764 128.993 165.739C137.46 159.714 143.84 151.201 147.245 141.383C150.65 131.565 150.911 120.93 147.992 110.956C145.073 100.983 139.12 92.1666 130.959 85.7333M75.0003 91.6667L100 116.667L150 66.6667L125 41.6667L75.0003 91.6667Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUresa);
export default __webpack_public_path__ + "static/media/URESA.b66646b625cc189a1677080f4038415a.svg";
export { ForwardRef as ReactComponent };